import { createSlice } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { PromotionStateType } from "types/promotion";

import { extraReducers } from "./promotion.extraReducers";

export const initialState: PromotionStateType = {
  isLoading: false,
  listPromotion: [],
};

const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {},
  extraReducers,
});

export const selectListPromotion = (state: ApplicationRootState) =>
  state.promotion.listPromotion;

export const selectIsLoadingPromotion = (state: ApplicationRootState) =>
  state.promotion.isLoading;

export default promotionSlice.reducer;
